var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoPersona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.6 93.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#e5185f;stroke-miterlimit:10;stroke-width:3px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.1,92.2H1.5c0-22.3,10.8-41.2,25.6-47.2,2.9,2.1,6.4,3.4,10.2,3.4s7.4-1.3,10.2-3.4c14.8,6.1,25.5,24.9,25.5,47.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.4,11.1v9c-1.5-1.1-3.5-2.3-5.1-2.6-2.6-.6-8.2-2.7-10.8,0-2.5,2.6-12.3,3.7-18.2,4.1V11.1c0-5.3,4.3-9.6,9.6-9.6h15c5.3,0,9.5,4.3,9.5,9.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.1,44.9c-4.2-3.1-6.8-8.1-6.8-13.7v-9.8c5.9-.4,15.8-1.5,18.2-4.1,2.6-2.7,8.2-.6,10.8,0,1.6,.4,3.6,1.6,5.1,2.7v11.2c0,5.6-2.7,10.5-6.8,13.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoPersona);
export default __webpack_public_path__ + "static/media/iconoPersona.9730c70ace8171ef631b8fe2aefd79bb.svg";
export { ForwardRef as ReactComponent };